import { NgModule } from 'ng-metadata/core';
import {SearchBarService} from './searchBar.service';
import 'angular-elastic-input';
import {PrmAdvancedSearch} from './advancedSearch.directive';
import {TabsAndScopesSelectorService} from './tabsAndScopesSelector/tabsAndScopesSelector.service';
import {PrmTabsAndScopesSelector, RecentScopesFilterPipe} from './tabsAndScopesSelector/tabsAndScopesSelector.directive';
import appConfigModule from '../../appConfig/appConfig.module';
import {PrmSearchBar} from './searchBar.directive';
import {PrmVoiceSearchToast} from './voiceSearchToast.directive';
import {VoiceSearchToastService} from './voiceSearchToast.service';
import { AdvancedSearchService } from './advancedSearch.service';

@NgModule({
    declarations: [
        PrmAdvancedSearch,
        PrmSearchBar,
        PrmTabsAndScopesSelector,
        PrmVoiceSearchToast,
        RecentScopesFilterPipe
    ],
    providers: [
        SearchBarService,
        TabsAndScopesSelectorService,
        VoiceSearchToastService,
        AdvancedSearchService

    ],
    imports:[
        'puElasticInput',
        appConfigModule.name
    ]
})
export class SearchBarModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/searchBar.module.ts